// #region Basket

// #region Coupon
function UseUserCoupon(CouponCode) {
    $.ajax({
        type: 'get',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutCart/AddCoupon?couponCode=" + CouponCode,
        async: true,
        success: function (dt) {
            if (dt.Status == true) {
                RefreshOrderSummary(true);
            }
            else {
                SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Kapat");
            }
        },
        error: function () {
            SwalGenerate("error", "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Kapat");
        }
    });
}

function DeleteUserCoupon() {
    $.ajax({
        type: 'post',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        url: "/" + $("#SmallLangCode").val() + '/p/CheckOutCart/RemoveCoupon',
        success: function (dt) {
            if (dt.Status == true) {
                RefreshOrderSummary(true);
            }
            else {
                SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Kapat");
            }
        },
        error: function () {
            SwalGenerate("error", "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Kapat");
        }
    });
}
// #endregion

// #region GiftPackage
function SetGift(wantGift, callback) {
    $.ajax({
        type: 'POST',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckoutCart/SetGift?wantGift=" + wantGift,
        cache: false,
        async: false,
        success: function (dt) {
            if (dt.Status == true) {
                RefreshOrderSummary(true);
                callback(wantGift);
            }
            else {
                SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Kapat");
                callback(false);
            }
        },
        error: function () {
            SwalGenerate("error", "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Kapat");
            callback(false);
        }
    });
}

function GiftPackageControl() {
    var wantGift = $("#GiftPackageChk").prop("checked");

    if (wantGift == true) {
        SetGift(wantGift);
    }
}
// #endregion

// #region BasketItems
function UpdateCartAmount(BasketID, Amount, LangID) {
    GenerateLocalLoading($(".OrderBasketContainer"), "show");

    $.ajax({
        type: 'GET',
        url: '/Cart/UpdateCartAmount',
        data: 'id=' + BasketID + "&adet=" + Amount + "&langID=" + LangID,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        cahce: false,
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {
                GetBasketItems();
                GiftPackageControl();
                RefreshOrderSummary();
            }
            else {
                GenerateLocalLoading($(".OrderBasketContainer"), "hide");
                SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
            }
        },
        error: function () {
            SwalGenerate("error", "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Kapat");
            GenerateLocalLoading($(".OrderBasketContainer"), "hide");
        }
    });
}

function RemoveFromCart(BasketID, LangID) {
    GenerateLocalLoading($(".OrderBasketContainer"), "show");

    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
        data: 'id=' + BasketID + "&langID=" + LangID,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        success: function (dt) {
            if (dt.Sonuc == true) {
                GetBasketItems();
                GiftPackageControl();
                RefreshOrderSummary();
            }
            else {
                GenerateLocalLoading($(".OrderBasketContainer"), "hide");
                SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
            }
        },
        error: function () {
            SwalGenerate("error", "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Kapat");
            GenerateLocalLoading($(".OrderBasketContainer"), "hide");
        }
    });
}

function GetBasketItems() {
    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + '/p/Checkout/sepet',
        dataType: 'html',
        cache: false,
        async: false,
        success: function (dt) {
            GenerateLocalLoading($(".OrderBasketContainer"), "hide");
            $(".OrderBasketContainer").html(dt);
        },
        error: function (dt) {
            GenerateLocalLoading($(".OrderBasketContainer"), "hide");
        }
    });
}
// #endregion

// #endregion

// #region LoginRegisterModal
function SetMemberless() {
    GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "show");

    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckoutValidation/SetMemberless?memberless=true",
        cache: false,
        success: function (dt) {
            if (dt.Status == true) {
                SetStep("adres", SetStepHandler);
            }
            else {
                SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Kapat");
                GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "hide");
            }
        },
        error: function () {
            SwalGenerate("error", "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Kapat");
            GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "hide");
        }
    });
}

function LoginRegisterFormSubmit(form) {
    GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "show");

    $.ajax({
        type: "POST",
        url: form.attr("action"),
        data: form.serialize(),
        dataType: "json",
        success: function (dt) {
            if (dt.Sonuc == true) {
                if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                    document.location = $("#register_FbRedirectUrl").val();
                }

                if (dt.JsonRs == "Reload" || dt.JsonRs == "Redirect") {
                    document.location.reload();
                }
                else {
                    SwalGenerate("success", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
                    GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "hide");

                    $("#LoginRegisterModal .ForgettenForm").trigger("reset");
                    $("#LoginRegisterModal .ForgettenForm .btn-cancel").trigger("click");
                }
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
                GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "hide");
            }
        },
        error: function () {
            SwalGenerate("error", "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Kapat");
            GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "hide");
        }
    });
}

// #endregion

// #region Address
function GetPartialAdress(AddressModal, EditLink) {
    if (!EditLink) {
        EditLink = "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/EditOrCreate";
    }

    $.ajax({
        type: "GET",
        url: EditLink,
        success: function (data) {
            AddressModal.find(".address-body").html(data);

            if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "TR"
                || $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "KKTC") { // TR
                $(".tr_group").show();
                $(".stateDiv").hide();
                $(".cityDiv").hide();
            }

            if (($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "TR"
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "KKTC")
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "CA"
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "US") { //Rest of world

                $(".tr_group").hide();
                $(".stateDiv").hide();
                $(".cityDiv").show();
            }

            if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "CA"
                ||
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "US") { //USA & CA

                $(".tr_group").hide();
                $(".stateDiv").show();
                $(".cityDiv").show();
            }

            $('html, body').animate({
                scrollTop: 0
            }, 0);

            $(".DeliveryAddress").addClass("d-none");
            $(".SelectAddresTypeCheck").addClass("d-none");

            PhoneFormatAccount();

            GenerateLocalLoading(AddressModal, "hide");
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            GenerateLocalLoading(AddressModal, "hide");
        }
    });
}

function GetAddressList() {
    GenerateLocalLoading($(".OrderContentDetails"), "show");

    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + '/p/Checkout/adres',
        success: function (data) {
            $(".OrderContentDetails .MyAddress").html(data);
            GenerateLocalLoading($(".OrderContentDetails"), "hide");
        },
        error: function () {
            GenerateLocalLoading($(".OrderContentDetails"), "hide");
        }
    });
}


function GetCities(countryID) {
    var AddressModal = $(".address-wrapper");
    GenerateLocalLoading(AddressModal, "show");

    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + '/p/User/GetCities',
        data: 'countryid=' + countryID,
        dataType: 'json',
        success: function (dt) {
            //$('.address-wrapper #CityID option').remove();

            //$('#CityID option').remove();
            $('.ddl_sehir option').remove();
            $('.ddl_ilce option').remove();
            $('.ddl_mahalle option').remove(); // Adres kısmında mahalle bilgisi alınacaksa burası sonradan ayarlanmalıdır

            for (var i = 0; i < dt.length; i++) {
                $('.address-wrapper .ddl_sehir').append($("<option></option>").attr("value", dt[i].ID).text(dt[i].Name));
            }

            if (dt.length > 0) {
                GetDistrict(dt[0].ID); // Seçilen şehir değişince seçilen şehrin ilçelerinin çekilmesi için bu istek geçiliyor
            }

            GenerateLocalLoading(AddressModal, "hide");
        },
        error: function () {
            GenerateLocalLoading(AddressModal, "hide");
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
        }
    });
}

function GetDistrict(CityID) {
    var AddressModal = $(".address-wrapper");
    GenerateLocalLoading(AddressModal, "show");

    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + '/p/User/GetTowns',
        data: 'cityid=' + CityID,
        dataType: 'json',
        success: function (dt) {
            //$('.address-wrapper #TownID option').remove();

            $('.ddl_ilce option').remove();
            $('.ddl_mahalle option').remove();  // Adres kısmında mahalle bilgisi alınacaksa burası sonradan ayarlanmalıdır

            for (var i = 0; i < dt.length; i++) {
                $('.address-wrapper .ddl_ilce').append($("<option></option>").attr("value", dt[i].ID).text(dt[i].Name));
            }

            // Mahalle bilgisi kullanılmaya başlandığında bu kısmı aç
            if (dt.length > 0) {
                GetQuarters(dt[0].ID); // Seçilen ilçe değişince seçilen ilçenin mahallelerinin çekilmesi için bu istek geçiliyor
            }

            GenerateLocalLoading(AddressModal, "hide");
        },
        error: function () {
            GenerateLocalLoading(AddressModal, "hide");
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
        }
    });
}

function GetQuarters(townID) {
    var AddressModal = $(".address-wrapper");
    GenerateLocalLoading(AddressModal, "show");

    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + '/p/User/GetQuarters',
        data: 'townID=' + townID,
        dataType: 'json',
        success: function (dt) {
            $('.address-wrapper #QuarterID option').remove();

            $('.address-wrapper .ddl_mahalle').append($("<option></option>").attr("value", "").text("Mahalle")).prop("selected", true);
            for (var i = 0; i < dt.length; i++) {
                $('.address-wrapper .ddl_mahalle').append($("<option></option>").attr("value", dt[i].ID).text(dt[i].Name));
            }

            GenerateLocalLoading(AddressModal, "hide");
        },
        error: function () {
            GenerateLocalLoading(AddressModal, "hide");
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
        }
    });
}


function DeleteAddress(AddressID) {
    var DeleteUrl = "/" + $("#SmallLangCode").val() + "/p/CheckoutAddress/Delete?adresid=" + AddressID;
    GenerateLocalLoading($(".MyAddress"), "show");

    $.ajax({
        type: "POST",
        url: DeleteUrl,
        cache: false,
        success: function (data) {
            if (data.Status) {
                SwalGenerate("success", "Adres kaydı silindi.", "İşlem Başarılı", "Kapat");
                GetAddressList();
            }
            else {
                SwalGenerate("error", data.ResultDescription, "İşlem Başarısız", "Tekrar Dene");
            }

            GenerateLocalLoading($(".MyAddress"), "hide");
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            GenerateLocalLoading(AddressBox, "hide");
        }
    });
}

function AddAddress(form) {
    $.ajax({
        type: form.attr("method"),
        url: "/" + $("#SmallLangCode").val() + '/p/CheckoutAddress/EditOrCreate',
        data: form.serialize(),
        dataType: 'json',
        success: function (data) {
            if (data.Status == true) {
                $(".address-wrapper .address-body").html("");
                GetAddressList();
                RefreshCargoList();

                SwalGenerate("success", data.ResultDescription, "İşlem Başarılı", "Kapat");

                $(".DeliveryAddress").removeClass("d-none");
                $(".SelectAddresTypeCheck").removeClass("d-none");
                $("#OrderSummary").removeClass("d-none");
                $(".AdresTitle").addClass("selected");
                $(".NewAddress").removeClass("selected");
            }
            else {
                SwalGenerate("error", data.ResultDescription, "İşlem Başarısız", "Tekrar Dene");
            }

            GenerateLocalLoading(form, "hide");
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            GenerateLocalLoading(form, "hide");
        }
    });
}

function SetAddress(id, addressType, isAllSelected) {
    if (id != null && id != "" && id != "" && id > 0) {
        GenerateLocalLoading($(".OrderContentDetails"), "show");

        $.ajax({
            type: 'POST',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/SetAddress?addressID=" + id + "&addressType=" + addressType + "&UpdateAllAddress=" + isAllSelected,
            cache: false,
            success: function (dt) {
                ReloadOnTimeOut();
                GenerateLocalLoading($(".OrderContentDetails"), "hide");

                if (dt.Status) {
                    RefreshOrderSummary(false);
                    RefreshCargoList();

                    $(".DeliveryAddress .CheckoutAddressContainer .CustomCheckbox").removeClass("oldSelect");
                }
                else {
                    if (dt.StatusText == "InvalidAddress") {
                        AddressModal = $(".address-wrapper");                        
                        GenerateLocalLoading(AddressModal, "show");

                        var EditUrl = "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/EditOrCreate?id=" + id;
                        GetPartialAdress(AddressModal, EditUrl);
                    }

                    SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Tekrar Dene");

                    
                    $(".DeliveryAddress .CheckoutAddressContainer .CustomCheckbox.selected input").prop("checked", false);
                    $(".DeliveryAddress .CheckoutAddressContainer .CustomCheckbox.selected label").removeClass("c_on");
                    $(".DeliveryAddress .CheckoutAddressContainer .CustomCheckbox.selected").removeClass("selected");

                    $(".oldSelect").addClass("selected");
                    $(".oldSelect").find("input").prop("checked", true);
                    $(".oldSelect").find("label").addClass("c_on");
                    $(".oldSelect").removeClass("oldSelect");
                }
            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
                GenerateLocalLoading($(".OrderContentDetails"), "hide");
            }
        });
    }
}

function SetCargoPrice(id) {
    CargoListContainer = $("#CargoList");
    GenerateLocalLoading(CargoListContainer, "show");

    if (id == null || id == "" || id == undefined) {
        id = $("#CargoTable tbody tr td label input:first").val();
    }

    $.ajax({
        type: 'post',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckoutAddress/SetCargoPrice?cargoPriceID=" + id,
        success: function (dt) {
            ReloadOnTimeOut();

            if (dt.Status == true) {
                RefreshOrderSummary();
                selectedCargoPriceID = id;

                $("#CargoTable tr td label input").prop("checked", false);
                $("#CargoTable tr td label input[value=" + id + "]").prop("checked", true);

                GenerateLocalLoading(CargoListContainer, "hide");
            }
            else {
                GenerateLocalLoading(CargoListContainer, "hide");

                $(".OrderContentDetails .AddressContainer .AddressBox.NewAddress").trigger("click");
            }
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            GenerateLocalLoading(CargoListContainer, "hide");
        }
    });
}

function RefreshCargoList() {
    $.ajax({
        type: 'GET',
        cache: false,
        async: true,
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/GetCargoList",
        success: function (dt) {
            $("#CargoList").html(dt);
        }
    });
}
// #endregion

// #region Payment
function SetAgreement(IsApproved) {
    if (IsApproved === true || IsApproved === false) {
        $.ajax({
            type: 'POST',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/SetAgreement?isApproved=" + IsApproved,
            cache: false,
            async: true,
            success: function (dt) {
                ReloadOnTimeOut();

                if (dt.Status == true) {
                    RefreshOrderSummary();
                }
                else {
                    SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Tekrar Dene");
                }
            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            }
        });
    }
}

function PaymentButtonControl() {
    if ($("#CurStep").val() == "Odeme") {
        if ($("#OrderSummary .SummaryAgrement .CustomCheckbox").hasClass("selected") && $("#PaymentAccordion .panel-collapse").hasClass("show")) {
            if ($("#PaymentAccordion .panel-collapse.show .PaymentDetail").hasClass("OnlinePos")) {
                if ($("#PaymentAccordion .panel-collapse.show .PaymentDetail.OnlinePos #CardForm .cardType").hasClass("Valid") || $("#creditcardlist").length > 0) {
                    $("#SummaryNextBackButtons #nextbtn").removeAttr("disabled");
                }
                else {
                    $("#SummaryNextBackButtons #nextbtn").prop("disabled", "true");
                }
            }
            else {
                $("#SummaryNextBackButtons #nextbtn").removeAttr("disabled");
            }
        }
        else {
            $("#SummaryNextBackButtons #nextbtn").prop("disabled", "true");
        }

        //if ($("#OrderSummary .SummaryAgrement .CustomCheckbox").hasClass("selected") && $("#PaymentAccordion .panel-collapse").hasClass("show")) {
        //    $("#SummaryNextBackButtons #nextbtn").removeAttr("disabled");
        //}
        //else {
        //    $("#SummaryNextBackButtons #nextbtn").prop("disabled", "true");
        //}
    }
}

function SetPaymentType(webPosInstallmentID, BankID) {
    if (BankID == undefined) { BankID = 0; }

    $.ajax({
        type: 'POST',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutPayment/SetPaymentType?webPosInstallmentID=" + webPosInstallmentID + "&bankID=" + BankID,
        cache: false,
        beforeSend: function () {
            GenerateLocalLoading($(".PaymentAccordionContainer"), "show");
        },
        complete: function () {
            GenerateLocalLoading($(".PaymentAccordionContainer"), "hide");
        },
        success: function (dt) {
            ReloadOnTimeOut();

            if (dt.Status) {
                RefreshOrderSummary(false);
            }
            else {
                SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Tekrar Dene");
            }
        },
        error: function () {
            SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
        }
    });
}

function SetPayAtDoorType(id) {
    if (id != null && id != "" && id != undefined && id > 0) {
        $.ajax({
            type: 'POST',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/SetPayAtDoorType?kapidaOdemeTuru=" + id,
            cache: false,
            success: function (dt) {
                ReloadOnTimeOut();

                if (dt.Status == true) {
                    RefreshOrderSummary();
                }
                else {
                    SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Tekrar Dene");
                }
            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            }
        });
    }
    else {
        SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
    }
}

// #region Credit Card
function CheckBinNumber() {
    var t_1 = $("#CardNumbers input#CardNumber1").val().replace(/\D/g, '');
    var t = t_1;

    if (t.length >= 6) {

        var tval6 = t.substring(0, 6);
        lastBin = tval6;

        if (lastBin != firstBin) {
            GetCardDetails(tval6);

            firstBin = lastBin;
        }
    }
}

function GetCardDetails(BinNo) {
    if (BinNo != null && BinNo != "" && BinNo != undefined && BinNo.length == 6) {

        $.ajax({
            type: 'GET',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/CardDetails",
            dataType: 'json',
            async: true,
            data: "BinNo=" + BinNo,
            success: function (jsonReturn) {
                if (jsonReturn.length !== 0) {

                    $.each(jsonReturn, function (index, element) {

                        var bnkCode = element.BankCode;
                        var cardType = element.CardType;
                        var cardName = element.CardName;
                        var installmentCount = element.InstallmentCount;

                        ShowInstallments(bnkCode, cardType, cardName, installmentCount);
                    });
                }
                else {
                    ShowInstallments(-1, "CREDIT_CARD");
                }
            }
        });
    }
}

function ShowInstallments(bankCode, cardType, CardName, installmentCount) {

    if (bankCode != -1) {

        var activeCls = "";

        switch (cardType) {
            case "CREDIT_CARD":
                activeCls = "KrediKarti";
                break;
            case "DEBIT_CARD":
                activeCls = "DebitCard";
                break;
        }

        var cardown = $("#CardOwner:first").val();
        var isAmex = false;
        var isShopAndMiles = false;

        if (CardName != null && CardName != "" && CardName != undefined && CardName.length > 0) {

            if (CardName.toUpperCase().indexOf("AMEX") > -1) {
                isAmex = true;
            }

            if (CardName.toUpperCase().indexOf("MASTER SM") > -1 || CardName.toUpperCase().indexOf("VISA SM") > -1) {
                isShopAndMiles = true;
            }
        }

        if (isAmex || isShopAndMiles) bankCode = "64"; //burda hangi banka gelmeli belirlenmeli

        InstallmentRows = $("#creditcard .Installments table tbody tr");
        InstallmentRows.removeClass("IsPasive").removeClass("IsActive");
        InstallmentRows.addClass("IsPasive");

        //alert("cardType: " + cardType);
        //alert("installmentCount: " + installmentCount);

        //banka kartı tek çekim olarak gösterilecektir.
        if (cardType == "DEBIT_CARD") {

            InstallmentRows.removeClass("IsActive");
            InstallmentRows.addClass("IsPasive");

            $(".DefaultInstallment").removeClass("IsPasive");
            $(".DefaultInstallment").addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }

        //kredi kartı tek çekim olanları gösterecek.
        if (cardType == "CREDIT_CARD" && installmentCount == 1) {

            InstallmentRows.removeClass("IsActive");
            InstallmentRows.addClass("IsPasive");

            $(".DefaultInstallment").removeClass("IsPasive");
            $(".DefaultInstallment").addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }

        //kredi kartı tüm taksitleri gösterecek.
        else if (cardType == "CREDIT_CARD") {
            InstallmentRows.removeClass("IsPasive");
            InstallmentRows.addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }

        else if (cardown == "BÜTÜN POSLAR") {
            InstallmentRows.removeClass("IsPasive");
            InstallmentRows.addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }

        //herhangi bir durumda default pos taksit (Tek çekim) gösterilecektir.
        else {
            InstallmentRows.removeClass("IsActive");
            InstallmentRows.addClass("IsPasive");

            $(".DefaultInstallment").removeClass("IsPasive");
            $(".DefaultInstallment").addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }
    }
}
// #endregion

// #endregion

function PrepareAddressAndPayment(curStep) {
    if (curStep != null && curStep != "" && curStep != undefined) {
        var url = "";

        if (curStep == "Sepet") {
            url = "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/PrepareUserAdresses";
        }
        else if (curStep == "Adres") {
            url = "/" + $("#SmallLangCode").val() + "/p/CheckOutPayment/PreparePayment";
        }

        if (url.length > 0) {
            $.ajax({
                type: 'POST',
                url: url,
                success: function (dt) {
                }
            });
        }
    }
}

function SetCreditCartAndStep(adim) {
    if ($("#CardForm").length > 0) {
        GenerateLocalLoading($("#OrderDetailArea"), "show");
        form = $("#CardForm");

        $.ajax({
            type: 'POST',
            async: true,
            cache: false,
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/SetCreditCard",
            data: form.serialize(),
            success: function (dt) {
                ReloadOnTimeOut();

                if (dt.Status == true) {
                    SetStep(adim, SetStepHandler);
                }
                else {
                    SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Tekrar Dene");
                    GenerateLocalLoading($("#OrderDetailArea"), "hide");
                }
            },
            error: function () {
                GenerateLocalLoading($("#OrderDetailArea"), "hide");
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            }
        });
    }
}

function RefreshOrderSummary() {
    GenerateLocalLoading($(".SummaryContainer"), "show");

    $.ajax({
        type: 'GET',
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOut/summary",
        beforeSend: function () {
            GenerateLocalLoading($(".SummaryContainer"), "show");

            if ($(".PaymentAccordionContainer").length > 0)
                GenerateLocalLoading($(".PaymentAccordionContainer"), "show");
        },
        complete: function () {
            GenerateLocalLoading($(".SummaryContainer"), "hide");

            if ($(".PaymentAccordionContainer").length > 0)
                GenerateLocalLoading($(".PaymentAccordionContainer"), "hide");
        },
        success: function (dt) {
            $("#OrderSummary").html(dt);

            PaymentButtonControl();

            //if (animateTop) {
            //    $('html,body').animate({ scrollTop: 500 }, 'slow', function () { });
            //}
        },
        error: function () {
            // GenerateLocalLoading($(".SummaryContainer"), "hide");
        }
    });
}

// #region Iyzico SetCardStorage

function SetCardStorage(IsApproved) {
    if (IsApproved === true || IsApproved === false) {
        $.ajax({
            type: 'POST',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/SetCardStorage?isApproved=" + IsApproved,
            cache: false,
            async: true,
            success: function (dt) {
                ReloadOnTimeOut();

                if (dt.Status == true) {
                    RefreshOrderSummary();
                }
                else {
                    SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Tekrar Dene");
                }
            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            }
        });
    }
}

// #endregion

// #region SetCardTokenToPayment

function SetCardTokenToPayment(CardToken) {
    if (CardToken != undefined && CardToken != null) {
        $.ajax({
            type: 'POST',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/SetCardTokenToPayment?cardToken=" + encodeURIComponent(CardToken),
            cache: false,
            async: true,
            success: function (dt) {
                ReloadOnTimeOut();

                if (dt.Status == true) {
                    RefreshOrderSummary();
                }
                else {
                    SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Tekrar Dene");
                }
            },
            error: function () {
                SwalGenerate("error", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.", "İşlem Başarısız", "Tekrar Dene");
            }
        });
    }
}

// #endregion


function SetStep(adim, callback) {
    var OrdGiftNote = "";
    if ($("#OrderNoteText").length > 0) {
        OrdGiftNote += "OrderNote=" + $("#OrderNoteText").val();
    }

    if ($("#OrderGiftNoteText").length > 0) {
        OrdGiftNote += "&GiftNote=" + $("#OrderGiftNoteText").val();
    }

    $.ajax({
        type: 'POST',
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/CheckoutValidation/SetStep?step=" + adim,
        data: OrdGiftNote,
        beforeSubmit: function () {
            GenerateLocalLoading($("#OrderDetailArea"), "show");
        },
        success: function (dt) {
            ReloadOnTimeOut();
            callback(dt.Status, dt, adim);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function SetStepHandler(status, dt, adim) {
    if (status) {

        if (adim == "progress") {
            $(".SummaryContainer #nextbtn").text($("#PleaseWait").val());
        }
        else if (adim == "login") {
            document.location.href = "/" + $("#SmallLangCode").val() + "/p/CheckOut/adres";
            return;
        }

        document.location.href = "/" + $("#SmallLangCode").val() + "/p/CheckOut/" + adim;

    } else {
        GenerateLocalLoading($("#OrderDetailArea"), "hide");

        if (dt.StatusText == "AskForLogin") {
            document.location.href = "/" + $("#SmallLangCode").val() + "/p/CheckOut/adres";
        }
        else if (dt.StatusText == "MissingAddress" || dt.StatusText == "InvalidAddress") {

            if ($("#CurStep").val() == "Adres") {
                var idValue = 0;

                if (dt.Result !== null && dt.Result !== undefined && dt.Result !== "") {
                    idValue = dt.Result;
                }

                if (idValue != null && idValue != "" && idValue != undefined && idValue > 0) {
                    AddressModal = $(".address-wrapper");
                    GenerateLocalLoading(AddressModal, "show");

                    var url = "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/EditOrCreate?id=" + idValue;

                    GetPartialAdress(AddressModal, url);
                }
                else {
                    $(".MyAddress .AddressContainer .AddressBox.NewAddress").trigger("click");
                    $(".CheckoutAddressContainer .NewAddress").trigger("click");
                }
            }
            else {
                SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Kapat");
            }
        }
        else {
            SwalGenerate("error", dt.ResultDescription, "İşlem Başarısız", "Kapat");
        }
    }
}